if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {

            // Only handle form submission on PDP pages, let ajaxify-cart handle collection pages
      const isProductPage = window.location.pathname.indexOf('/products/') !== -1;
      if (!isProductPage) {
        // On collection pages, let the form submit normally so ajaxify-cart can handle it
        return;
      }
      
      
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');


      
       // IMPORTANT: Read quantity value BEFORE creating FormData
      // This ensures we get the current live value, not a cached/default value
      let quantityInput = null;
      let quantity = 1;
      
      // Try to find quantity input in multiple ways (BEFORE FormData creation)
      // 1. Inside the form element
      quantityInput = this.form.querySelector('input[name="quantity"]');
      
      // 2. Inside product-form element (in case quantity is outside form)
      if (!quantityInput) {
        quantityInput = this.querySelector('input[name="quantity"]');
      }
      
      // 3. Inside quantity-input custom element within product-form
      if (!quantityInput) {
        const quantityInputElement = this.querySelector('quantity-input');
        if (quantityInputElement) {
          quantityInput = quantityInputElement.querySelector('input[name="quantity"]');
        }
      }
      
      // 4. Using form attribute linking
      if (!quantityInput && this.form.id) {
        quantityInput = document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
      }
      
      // 5. Fallback: search for any quantity input related to this product form
      if (!quantityInput) {
        const quantityInputs = document.querySelectorAll('input[name="quantity"]');
        for (let i = 0; i < quantityInputs.length; i++) {
          const input = quantityInputs[i];
          // Check if input is linked via form attribute or inside product-form
          if (input.getAttribute('form') === this.form.id || 
              input.closest('product-form') === this ||
              input.closest('.product-form__quantity')) {
            quantityInput = input;
            break;
          }
        }
      }
      
      // Get the quantity value from the input (read it fresh at submission time)
      // IMPORTANT: Read .value property (not getAttribute) to get current live value
      // Read it IMMEDIATELY to prevent any reset from affecting it
      if (quantityInput) {
        // Read the value directly from the input element's .value property
        // This gets the current value that the user has entered/changed
        const inputValue = quantityInput.value;
        if (inputValue && inputValue !== '' && inputValue !== null && inputValue !== undefined) {
          quantity = parseInt(inputValue, 10);
          // Validate quantity - must be a valid number >= 1
          if (isNaN(quantity) || quantity < 1) {
            quantity = 1;
          }
        } else {
          // If input value is empty or invalid, default to 1
          quantity = 1;
        }
        
        // Store the quantity value we read to prevent it from being lost
        // This ensures even if the input gets reset, we still have the correct value
        this._lastQuantityValue = quantity;
        this._lastQuantityInput = quantityInput; // Store reference for later use
      } else {
        // If no input found, try to use last stored value, otherwise default to 1
        quantity = this._lastQuantityValue || 1;
      }
      
      // Debug: Log the quantity being used (remove in production if needed)
      // console.log('Add to cart quantity:', quantity, 'from input value:', quantityInput ? quantityInput.value : 'no input found');


      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

            
      // Always override quantity in FormData with the value we just read
      formData.set('quantity', quantity.toString());
      
      
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.form.querySelector('button.product-form__submit').classList.add('hide-this');
          this.querySelector('limiter-alert').style.display = 'block';
          this.cartNotification.renderContents(response);

          document.dispatchEvent(new CustomEvent('cart:item:added', {
            detail: {
              response: response,
              items_added: [{
                quantity: quantity,
                id: parseInt(formData.get('id'), 10)
              }]
            }
          }));

                    
          // After successful add to cart, preserve the quantity value if it was set
          // This prevents the input from being reset to default value
          const savedQuantityInput = this._lastQuantityInput;
          if (savedQuantityInput && this._lastQuantityValue && this._lastQuantityValue > 1) {
            // Use setTimeout to ensure DOM updates are complete
            setTimeout(() => {
              if (savedQuantityInput) {
                const currentValue = savedQuantityInput.value;
                const minValue = savedQuantityInput.getAttribute('min') || '1';
                // If input was reset to default/minimum value, restore the user's selected quantity
                if (currentValue === '1' || currentValue === minValue) {
                  savedQuantityInput.value = this._lastQuantityValue;
                }
              }
            }, 100);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('limiter-alert')) {
  class limiterAlert extends HTMLElement {
    constructor() {
      super();
      this.add = this.querySelector('.product-form__submit');
      this.cancel = this.querySelector('.action__cancel');
      this.proceed = this.querySelector('.action__continue');
      this.form = this.closest('form');
      this.submitBtn = this.form?.querySelector('button.product-form__submit');
      this.dismissed = false;
      this.continued = false;

      if(this.form?.querySelector('[name="product_type"]')?.value === 'Custom Order') {
        this.isCustom = true;
      } else {
        this.isCustom = false;
      }

      // events - only add listeners if elements exist
      if (this.cancel) {
        this.cancel.addEventListener('click', this.closeModal.bind(this));
      }
      if (this.add) {
        this.add.addEventListener('click', this.checkProducts.bind(this));
      }
      if (this.proceed) {
        this.proceed.addEventListener('click', this.continue.bind(this));
      }
    }

    closeModal() {
      this.removeAttribute('open');
      this.dismissed = true;
    }

    continue() {
      let _that = this;
      let submitBtn = this.submitBtn;
      
      // If submitBtn is not found, try to find it again
      if (!submitBtn && this.form) {
        submitBtn = this.form.querySelector('button.product-form__submit');
      }
      
      fetch(`/cart/clear.js`)
      .then((response) => response.json())
      .then((response) => {
        const cartCountBubble = document.querySelector('.cart-count-bubble span');
        if (cartCountBubble) {
          cartCountBubble.innerText = '0';
        }
        _that.removeAttribute('open');
        _that.continued = true;
        _that.style.display = 'none';
        if (submitBtn) {
          submitBtn.classList.remove('hide-this');
          if (submitBtn.form) {
            submitBtn.form.requestSubmit();
          } else if (_that.form) {
            _that.form.requestSubmit();
          }
        } else if (_that.form) {
          _that.form.requestSubmit();
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
    }

    checkProducts(e) {
      // Prevent default behavior (especially important for <a> tags)
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      
      let _that = this;
      let submitBtn = this.submitBtn;
      
      // If submitBtn is not found, try to find it again or use the add button
      if (!submitBtn) {
        submitBtn = this.closest('form')?.querySelector('button.product-form__submit');
        if (!submitBtn && this.add && this.add.tagName === 'BUTTON') {
          submitBtn = this.add;
        }
      }
      
      // If still no submit button found, try to trigger form submission directly
      if (!submitBtn && this.form) {
        // Fallback: trigger form submission directly
        const formSubmitEvent = new Event('submit', { bubbles: true, cancelable: true });
        this.form.dispatchEvent(formSubmitEvent);
        return;
      }
      
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if(!this.continued) {
        fetch(`${routes.cart_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if(response.items.length > 0) {
            let customInCart = false;
            let normalProductsInCart = false;
            response.items.forEach(item => {
              if(item.product_type == "Custom Order"){
                customInCart = true;
              } else {
                normalProductsInCart = true;
              }
            });

            if(this.isCustom && normalProductsInCart) {
              _that.setAttribute('open', '');
            } else if (!this.isCustom && customInCart){
              _that.setAttribute('open', '');
            } else {
              _that.style.display = 'none';
              if (submitBtn) {
                submitBtn.classList.remove('hide-this');
                submitBtn.click();
              } else if (_that.form) {
                _that.form.requestSubmit();
              }
            }
          } else {
            _that.style.display = 'none';
            if (submitBtn) {
              submitBtn.classList.remove('hide-this');
              submitBtn.click();
            } else if (_that.form) {
              _that.form.requestSubmit();
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
        });
      } else {
        _that.style.display = 'none';
        if (submitBtn) {
          submitBtn.classList.remove('hide-this');
          submitBtn.click();
        } else if (_that.form) {
          _that.form.requestSubmit();
        }
      }
    }
  }

  customElements.define('limiter-alert', limiterAlert);
}


// Handle sticky ATC button on mobile
(function() {
  let scrollTimer = null;
  let isSticky = false;

  function checkSticky() {
    if (window.innerWidth > 480) return;

    const cartButton = document.querySelector('.limiter_alert_cart');
    const stickyContainer = document.querySelector('.sticky-button-container_ccz');
    
    if (!cartButton || !stickyContainer) return;

    const rect = cartButton.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    const isVisible = rect.bottom > 0 && rect.top < windowHeight;

    if (isVisible && isSticky) {
      stickyContainer.classList.remove('sticky');
      isSticky = false;
    } else if (!isVisible && !isSticky) {
      stickyContainer.classList.add('sticky');
      isSticky = true;
    }
  }

  window.addEventListener('scroll', function() {
    if (scrollTimer) clearTimeout(scrollTimer);
    scrollTimer = setTimeout(checkSticky, 100);
  }, { passive: true });

  window.addEventListener('DOMContentLoaded', checkSticky);
  window.addEventListener('resize', function() {
    if (window.innerWidth > 480) {
      const stickyContainer = document.querySelector('.sticky-button-container_ccz');
      if (stickyContainer) {
        stickyContainer.classList.remove('sticky');
        isSticky = false;
      }
    } else {
      checkSticky();
    }
  });
})();


// Handle sticky variant select functionality
window.addEventListener('DOMContentLoaded', function() {
  const stickyVariantSelect = document.querySelector('.sticky-product-variant-options-select');
  const mainVariantSelects = document.querySelectorAll('variant-selects select, variant-radios input[type="radio"]');
  const stickyPriceElement = document.querySelector('.sticky-product-price-text');
  const stickyAddToCartButton = document.querySelector('#add-to-cart-button');
  const stickyAddToCartText = document.querySelector('#add-to-cart-text');
  const mainProductForm = document.querySelector('product-form');
  
  if (!stickyVariantSelect) return;

  // Get product data
  const productDataScript = document.querySelector('#product-data');
  let productVariants = [];
  if (productDataScript) {
    try {
      productVariants = JSON.parse(productDataScript.textContent);
    } catch (error) {
      console.error('Error parsing product data:', error);
    }
  }
  
  if (productVariants.length === 0) {
    console.warn('No product variants found');
    return;
  }

  // Function to update sticky elements based on selected variant
  function updateStickyElements(variantId) {
    const variant = productVariants.find(v => v.id.toString() === variantId.toString());
    if (!variant) {
      console.warn('Variant not found:', variantId);
      return;
    }

    // Update price
    if (stickyPriceElement) {
      // Try to use Shopify's money format if available
      if (window.Shopify && window.Shopify.formatMoney) {
        stickyPriceElement.textContent = window.Shopify.formatMoney(variant.price);
      } else {
        // Fallback to basic currency formatting
        const price = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD'
        }).format(variant.price / 100);
        stickyPriceElement.textContent = price;
      }
    }

    // Update add to cart button state
    if (stickyAddToCartButton && stickyAddToCartText) {
      if (variant.available) {
        stickyAddToCartButton.removeAttribute('disabled');
        stickyAddToCartText.textContent = window.variantStrings?.addToCart || 'Add to cart';
      } else {
        stickyAddToCartButton.setAttribute('disabled', 'disabled');
        stickyAddToCartText.textContent = window.variantStrings?.soldOut || 'Sold out';
      }
    }

    // Update main form variant input
    const mainVariantInput = mainProductForm?.querySelector('input[name="id"]');
    if (mainVariantInput) {
      mainVariantInput.value = variantId;
      mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Handle sticky variant select change
  stickyVariantSelect.addEventListener('change', function(e) {
    const selectedVariantId = e.target.value;
    updateStickyElements(selectedVariantId);
  });

  // Sync with main variant selects
  mainVariantSelects.forEach(select => {
    select.addEventListener('change', function() {
      // Find the currently selected variant from main form
      const mainVariantInput = mainProductForm?.querySelector('input[name="id"]');
      if (mainVariantInput && mainVariantInput.value) {
        stickyVariantSelect.value = mainVariantInput.value;
        updateStickyElements(mainVariantInput.value);
      }
    });
  });

  // Listen for variant changes from the main variant selector components
  const variantRadios = document.querySelector('variant-radios');
  const variantSelects = document.querySelector('variant-selects');
  
  if (variantRadios) {
    variantRadios.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        stickyVariantSelect.value = e.detail.variant.id;
        updateStickyElements(e.detail.variant.id);
      }
    });
  }
  
  if (variantSelects) {
    variantSelects.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        stickyVariantSelect.value = e.detail.variant.id;
        updateStickyElements(e.detail.variant.id);
      }
    });
  }

  // Initialize sticky elements with current variant
  const currentVariantId = stickyVariantSelect.value;
  if (currentVariantId) {
    updateStickyElements(currentVariantId);
  }

  // Watch for changes in the main variant input
  const mainVariantInput = mainProductForm?.querySelector('input[name="id"]');
  if (mainVariantInput) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          const newVariantId = mainVariantInput.value;
          if (newVariantId && newVariantId !== stickyVariantSelect.value) {
            stickyVariantSelect.value = newVariantId;
            updateStickyElements(newVariantId);
          }
        }
      });
    });
    
    observer.observe(mainVariantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  // Handle sticky add to cart button click
  if (stickyAddToCartButton) {
    stickyAddToCartButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Trigger the main product form submission
      const mainSubmitButton = mainProductForm?.querySelector('button[type="submit"]');
      if (mainSubmitButton && !mainSubmitButton.hasAttribute('disabled')) {
        mainSubmitButton.click();
      }
    });
  }
});